
const contactUs = {
  'contactUs.title': 'Contattaci',
  'contactUs.subtitle': 'Siamo qui per aiutarti',
  'contactUs.whatsapp.title': 'Contattaci tramite WhatsApp',
  'contactUs.email.title': 'Contattaci via email',
  'contactUs.whatsapp.urgent': 'Per richieste urgenti, contattaci direttamente su WhatsApp. Il nostro team ti risponderà al più presto.',
  'contactUs.languages.english': 'English',
  'contactUs.languages.italian': 'Italiano',
  'contactUs.languages.spanish': 'Español',
  'contactUs.languages.german': 'Deutsch',
  'contactUs.languages.croatian': 'Hrvatski',
  'contactUs.languages.turkish': 'Türkçe',
  'contactUs.languages.french': 'Français',
  'contactUs.languages.arabic': 'العربية',
};

export default contactUs;
